// extracted by mini-css-extract-plugin
module.exports = {"highlight":"string_highlight__3jGjj","sentence":"string_sentence__MQUMq"};